<div class="container-fluid m-0 p-0" *ngIf="!showLoader">
    <div class="row">
        <div class="col-12">
            <div class="row bg-white border m-0 p-3 py-4">
                <div class="col-md-12">
                    <div class="col-md-12 d-flex flex-wrap justify-content-center">
                        <button type="button" class="btn btn-outline-secondary m-2 rounded-0" data-toggle="modal"
                            data-target="#rejectModal"
                            *ngIf="!updating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - REJECT')">
                            {{"INVAILED" | translate | titlecase}}</button>
                        <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal"
                            data-target="#acceptModal"
                            *ngIf="!updating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - VERIFY')"><i
                                class="fas fa"></i>
                            {{"VERFIED" | translate | titlecase}}</button>  

                            <!-- resend verfication mails -->
                            <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal" (click)="onSendingVerficationMail()"><i
                                class="fas fa"></i>
                            {{ "SEND_VERFICATION_MAIL" | translate | titlecase }}</button>

                            <!-- update email and NationalId buttons -->
                            <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal" data-target="#updateEmail"><i
                                    class="fas fa"></i>
                                {{ "UPDATE_EMAIL" | translate | titlecase }}</button>
                            <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal" data-target="#updateNationalId"><i
                                    class="fas fa"></i>
                                {{ "UPDATE_NATIONAL_ID" | translate | titlecase }}</button>
                                <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal" data-target="#archievingCand"><i
                                    class="fas fa"></i>
                                {{ "ARCHIEVING" | translate | titlecase }}</button>                                
                        <app-loader [show]="updating"></app-loader>
                    </div>
                    <br />
                    <!-- testing -->
                    <app-cand-card [candData]="candData"></app-cand-card>
                    <!-- <form [formGroup]="findServiceNumber" (change)="findServiceNumberChange()"
                        (submit)="findServiceNumberSubmit()" class="row">
                        <div class="col-md-12 mb-3">
                            <h5 class="text-bold">Find service number</h5>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="text-bold">Area Code</label>
                                <select class="custom-select" formControlName="areaCode">
                                    <option value="">Select</option>
                                    <option value={{areaCodeObject?.areaCode}}
                                        *ngFor="let areaCodeObject of areaCodeObjects">{{areaCodeObject?.areaCode}} -
                                        {{areaCodeObject?.areaName}}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="findServiceNumber.controls.areaCode.touched && findServiceNumber.controls.areaCode.invalid && findServiceNumber.dirty">
                                    Please select area code
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="text-bold">Service Number</label>
                                <input type="text" class="form-control" placeholder="Number"
                                    formControlName="serviceNumber">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="findServiceNumber.controls.serviceNumber.touched && findServiceNumber.controls.serviceNumber.invalid && findServiceNumber.dirty">
                                    service number invalid
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 align-self-end">
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-block"
                                    [class.disabled]="searching">Search</button>
                            </div>
                        </div>
                    </form> -->
                    <div class="row mt-4">
                        <div class="col-12" style="padding: 0px">

                            <!-- <div class="row bg-white border m-0 py-4">
                                <div class="col-md-12">
                
                                    <div class="row">
                                        <div class="col-md-12 justify-content-center align-items-center text-center my-5">
                                            <img src="assets/images/search.svg" class="img-fluid my-5">
                                        </div>
                                    </div>
                                </div>
                            </div> -->


                            <!-- <div class="row m-0 py-4">
                                <div class="col-md-12"> -->
                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" [class.active]="true" [id]="'tab-button-0'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-1'" type="button"
                                        role="tab" (click)="activateNumber(0)">
                                        {{ "TAB_BASIC_DATA" | translate | titlecase }}
                                        <!-- <span class="cursor-pointer d-inline-block ml-2 text-danger"
                                                    (click)="closeNumber(i)">&times;</span> -->
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-1'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-2'" type="button"
                                        role="tab" (click)="activateNumber(1)">
                                        {{ "TAB_GENERAL_DATA" | translate | titlecase }}
                                        <!-- <span class="cursor-pointer d-inline-block ml-2 text-danger"
                                                    (click)="closeNumber(i)">&times;</span> -->
                                    </button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-2'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-3'" type="button"
                                        role="tab" (click)="activateNumber(2)">
                                        {{ "TAB_GENERAL_DATA_2" | translate | titlecase }}
                                        <!-- <span class="cursor-pointer d-inline-block ml-2 text-danger"
                                                    (click)="closeNumber(i)">&times;</span> -->
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-3'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-4'" type="button"
                                        role="tab" (click)="activateNumber(3)">
                                        {{ "TAB_GENERAL_DATA_3" | translate | titlecase }}
                                        <!-- <span class="cursor-pointer d-inline-block ml-2 text-danger"
                                                    (click)="closeNumber(i)">&times;</span> -->
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation" *ngIf="candFlag">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-4'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-5'" type="button"
                                        role="tab" (click)="activateNumber(4)">
                                        {{ "TAB_PERSONAL_INTERVIEW" | translate | titlecase }}
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation" *ngIf="candFlag">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-5'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-6'" type="button"
                                        role="tab" (click)="activateNumber(5)">
                                        {{ "TAB_MEDICAL_CHECH" | translate | titlecase }}
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation" *ngIf="candFlag">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-6'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-7'" type="button"
                                        role="tab" (click)="activateNumber(6)">
                                        {{ "TAB_MOODEL_TEST" | translate | titlecase }}
                                    </button>
                                </li>

                                <li class="nav-item" role="presentation" *ngIf="candFlag">
                                    <button class="nav-link" [class.active]="false" [id]="'tab-button-7'"
                                        data-toggle="tab" [attr.data-target]="'#cand-preview-tab-8'" type="button"
                                        role="tab" (click)="activateNumber(7)">
                                        {{ "TAB_EVALUATE" | translate | titlecase }}
                                    </button>
                                </li>
                            </ul>
                            <div class="tab-content p-4 bg-white border-left border-right">
                                <!-- <div class="tab-pane fade" [class.active]="i==0" [class.show]="i==0"
                                            *ngFor="let tabContent of tabsContent;let i = index" [id]="'tab-'+tabContent.id"
                                            role="tabpanel" [attr.aria-labelledby]="'tabContent'+i"> -->
                                <div class="tab-pane fade" [class.active]="true" [class.show]="true"
                                    [id]="'cand-preview-tab-1'" role="tabpanel" [attr.aria-labelledby]="'tabContent-0'">
                                    <app-cand-basic-data [candData]="candData"></app-cand-basic-data>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-2'" role="tabpanel" [attr.aria-labelledby]="'tabContent-1'">
                                    <app-cand-section2 [candData]="candData"></app-cand-section2>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-3'" role="tabpanel" [attr.aria-labelledby]="'tabContent-2'">
                                    <app-cand-section3 [candData]="candData"></app-cand-section3>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-4'" role="tabpanel" [attr.aria-labelledby]="'tabContent-3'">
                                    <app-cand-section4 [candData]="candData"></app-cand-section4>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-5'" role="tabpanel" [attr.aria-labelledby]="'tabContent-4'">
                                    <app-cand-personal-interview [candData]="candData"></app-cand-personal-interview>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-6'" role="tabpanel" [attr.aria-labelledby]="'tabContent-5'">
                                    <app-cand-medical-check [candData]="candData"></app-cand-medical-check>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-7'" role="tabpanel" [attr.aria-labelledby]="'tabContent-6'">
                                    <app-cand-moodel-test [candData]="candData"></app-cand-moodel-test>
                                </div>
                                <div class="tab-pane fade" [class.active]="false" [class.show]="false"
                                    [id]="'cand-preview-tab-8'" role="tabpanel" [attr.aria-labelledby]="'tabContent-7'">
                                    <app-cand-evaluate [candData]="candData"></app-cand-evaluate>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 d-flex flex-wrap justify-content-center">
                                        <button type="button" class="btn btn-outline-secondary m-2 rounded-0"
                                            data-toggle="modal" data-target="#rejectModal"
                                            *ngIf="!updating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - REJECT')">
                                            {{"INVAILED" | translate | titlecase}}</button>
                                        <button type="button" class="btn btn-primary m-2 rounded-0" data-toggle="modal"
                                            data-target="#acceptModal"
                                            *ngIf="!updating && globals.checkUserHasPermission('CANDIDATE_INQUIRY - VERIFY')"><i
                                                class="fas fa"></i>
                                            {{"VERFIED" | translate | titlecase}}</button>
                                        <app-loader [show]="updating"></app-loader>
                                    </div>
                                </div>
                            </div>
                            <!-- </div>
                            </div> -->
                            <!-- </div> -->
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <!-- <app-loader [show]="searching"></app-loader> -->

    </div>

    <app-loader [show]="showLoader"></app-loader>

    <!-- <div class="modal fade" id="ResetGPONAlertModal" tabindex="-1" aria-labelledby="ResetGPONAlertModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center">
                <div class="p-2">This action will enforce GPON port to be restarted which will
                    cause service outage for all customers using this port, the affected customers may be (48*32)
                    customers.Are you sure you want to continue?
                </div>
                <div class="p-2">
                    <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                            class="fas fa-times-circle"></i>No</a>
                    <a type="button" class="btn btn-link text-danger" (click)="restGPONPort()">Yes</a>

                </div>
            </div>
        </div>
    </div>
</div> -->

    <!-- <div class="modal fade" id="ResetGPONAlertModal" tabindex="-1" aria-labelledby="ResetGPONAlertModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Reset GPON Port</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>This action will enforce GPON port to be restarted which will
                    cause service outage for all customers using this port, the affected customers may be (48*32)
                    customers.<br />Are you sure you want to continue?</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="restGPONPort()">Yes</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div> -->

    <div class="modal fade" id="acceptModal" tabindex="-1" aria-labelledby="acceptModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <form class="modal-content col-md-12" [formGroup]="applicationVerifyPopUp">
                    <div class="modal-body px-md-12">
                        <div class="row">
                            <div class="col-md-4 form-group">
                                <label class="text-bold">{{ "INVITATION_BATCH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="patchNumber">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="applicationVerifyPopUp.controls.patchNumber.touched && applicationVerifyPopUp.controls.patchNumber.invalid && applicationVerifyPopUp.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="text-bold">{{ "INVITATION_DATE" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="interViewDate"
                                    min="{{ minDate }}">
                                <!-- <input type="time" class="form-control" formControlName="interViewTime"> -->
                                <!-- <input type="datetime-local" class="form-control" formControlName="interViewDate"> -->
                                <!-- <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Date Time"> -->
                                <!-- <owl-date-time #dt1></owl-date-time> -->
                                <!-- <input class="form-control datepicker" formControlName="interViewDate"> -->
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="(applicationVerifyPopUp.controls.interViewDate.touched && applicationVerifyPopUp.controls.interViewDate.invalid && applicationVerifyPopUp.dirty)">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group">
                                <label class="text-bold">{{ "INVITATION_TIME" | translate | titlecase }}</label>
                                <input type="time" class="form-control" formControlName="interViewTime">
                                <!-- <input type="datetime-local" class="form-control" formControlName="interViewDate"> -->
                                <!-- <input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Date Time"> -->
                                <!-- <owl-date-time #dt1></owl-date-time> -->
                                <!-- <input class="form-control datepicker" formControlName="interViewDate"> -->
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="(applicationVerifyPopUp.controls.interViewTime.touched && applicationVerifyPopUp.controls.interViewTime.invalid && applicationVerifyPopUp.dirty)">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 font-16 text-center d-flex justify-content-between">
                                <div class="p-2">
                                    <i class="fas fa-check text-success"></i>
                                </div>
                                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                                <a type="button" class="btn btn-link text-success"
                                    (click)="changeCandStatusToVerify(pendingEvalStatus)">{{
                                    "YES" | translate | titlecase }}</a>
                                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"
                                    #closeVerifyAlert><i class="fas fa-times-circle"></i></a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="modal fade" id="rejectModal" tabindex="-1" aria-labelledby="rejectModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">

                <div class="modal-body font-16 text-center d-flex justify-content-between">
                    <div class="p-2">
                        <i class="fas fa-trash text-danger"></i>
                    </div>
                    <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                    <a type="button" class="btn btn-link text-danger" (click)="changeCandStatus(rejectStatus)"
                        data-dismiss="modal">{{ "YES"
                        | translate | titlecase }}</a>
                    <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                            class="fas fa-times-circle"></i></a>
                </div>
            </div>
        </div>
    </div>

    <!-- update cand email address pop up -->
    <div class="modal fade" id="updateEmail" tabindex="-1" aria-labelledby="updateEmail" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
            <form class="modal-content col-md-6" [formGroup]="updateEmailPopUp" validate (submit)="updateCandEmail()">
                <div class="modal-header">
                    <h5 class="modal-title" id="UpdateEmailLabel">{{ "UPDATE_EMAIL" | translate | titlecase
                        }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-md-12">
                    <div class="row">
                        <div class="col-md-12 form-group px-md-5 mb-4">
                            <label class="font-bold">{{ "EMAIL_LABEL" | translate | titlecase }}</label>
                            <input type="text" class="form-control" email="true" placeholder="" formControlName="updatedEmail">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="close-UpdateEmailPopUp" class="btn btn-outline-secondary"
                        data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                    <button type="submit" class="btn btn-primary">{{ "UPDATE" | translate | titlecase }}</button>
                </div>
            </form>
        </div>
    </div>

   <!-- update NationalId Pop up -->
    <div class="modal fade" id="updateNationalId" tabindex="-1" aria-labelledby="updateNationalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
            <form class="modal-content col-md-6" [formGroup]="updateCandNationalIdPopUp" validate (submit)="updateCandNationalId()">
                <div class="modal-header">
                    <h5 class="modal-title" id="updateNationalIdLabel">{{ "UPDATE_NATIONAL_ID" | translate | titlecase
                        }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-md-12">
                    <div class="row">
                        <div class="col-md-12 form-group px-md-5 mb-4">
                            <label class="font-bold">{{ "NATIONAL_ID_LABEL" | translate | titlecase }}</label>
                            <input type="text" class="form-control"  placeholder="" formControlName="updatedNationalId">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="close-UpdateNationalIdPopUp" class="btn btn-outline-secondary"
                        data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                    <button type="submit" class="btn btn-primary">{{ "UPDATE" | translate | titlecase }}</button>
                </div>
            </form>
        </div>
    </div>    

       <!-- archieving Cand-->
       <div class="modal fade" id="archievingCand" tabindex="-1" aria-labelledby="archievingCand" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
            <form class="modal-content col-md-6" [formGroup]="archievingCandPopUp" validate (submit)="onCandArchieving()">
                <div class="modal-header">
                    <h5 class="modal-title" id="archievingCandLabel">{{ "ARCHIEVING" | translate | titlecase
                        }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-md-12">
                    <div class="row">
                        <div class="col-md-12 form-group px-md-5 mb-4">
                            <label class="font-bold">{{ "REMARKS" | translate | titlecase }}</label>
                            <input type="text" class="form-control"  placeholder="" formControlName="remarks">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="close-ArchievingCandPopUp" class="btn btn-outline-secondary"
                        data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                    <button type="submit" class="btn btn-primary">{{ "ARCHIEVING" | translate | titlecase }}</button>
                </div>
            </form>
        </div>
    </div>    